import React, { useState, useEffect , useMemo, useRef} from "react";
import { Container, Card, Form, Button, Row, Col, Nav, Dropdown } from "react-bootstrap";
import { FaArrowLeft, FaCog, FaCalendarAlt, FaFileAlt,FaGlobe,FaCheckCircle} from "react-icons/fa";
import "bootstrap/dist/css/bootstrap.min.css";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { API_AGENTS_LIST, API_AGENT_GROUPS_LIST, API_VOICE_CAMPAIGNS_GET_ONE, API_CONTACT_GROUP_MEMBERS_UNDER_ONE_GROUP, API_PROMPT_ACTIVE_LIST } from "../../../service/url";
import { getApiCall } from "../../../service/httpCall";
import { useNavigate, useParams } from "react-router-dom";
import { useAuth, errorCheck } from "../auth/auth-utils";
import StatsBar from "./stats-bar";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import AsyncStorage from '@react-native-async-storage/async-storage';
import { USER_ROLES } from '../../../utilities/constant';
import Loader from "../../../components/partials/components/loader";
import {
  Tooltip, Legend, ResponsiveContainer, PieChart,
  Pie, Cell
} from 'recharts';

// ChartJS.register(ArcElement, Tooltip, Legend);

const ScrollBox = ({ data }) => {
  if (!data) return "—";

  let parsedData = data;

  try {
    parsedData = typeof data === "string" ? JSON.parse(data) : data;
  } catch {}

  return (
    <div
      className="campaign-detail-scrollbox"
      style={{
        maxWidth: "280px",
        maxHeight: "130px",
        overflow: "auto",
        border: "1px solid #e0e0e0",
        borderRadius: "6px",
        padding: "0.5rem",
        fontSize: "0.8rem",
      }}
    >
      <pre style={{ margin: 0 }}>
        {typeof parsedData === "object"
          ? JSON.stringify(parsedData, null, 2)
          : parsedData}
      </pre>
    </div>
  );
};

const payloadBody = (rowData) => (
  <ScrollBox data={rowData.payload} />
);

const smsHeaderBody = (rowData) => (
  <ScrollBox data={rowData.sms_webhook?.header} />
);

const smsPayloadBody = (rowData) => (
  <ScrollBox data={rowData.sms_webhook?.payload} />
);

const webhookBody = (rowData) => (
  <ScrollBox data={rowData.webhook?.body_json} />
);

const webhookHeader = (rowData) => (
  <ScrollBox data={rowData.webhook?.header_json} />
);

const CampaignDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [step, setStep] = useState(1);
  const [showToast, setShowToast] = useState(false);
  const [toastProps, setToastProps] = useState(null);
  const [campaignName, setCampaignName] = useState("Test")
  const [campaignPrompts, setCampaignPrompts] = useState([]);
  const [allPrompts, setAllPrompts] = useState([]);
  const [filteredPrompts, setFilteredPrompts] = useState([]);
  const [callGroupRows, setCallGroupRows] = useState([]);
  const [webhookRows, setWebhookRows] = useState([]);
  const [numbersRows, setNumbersRows] = useState([]);
  const [contactMembers, setContactMembers] = useState([]);
  const [scriptDetails, setScriptDetails] = useState([]);
  const [scheduleRows, setScheduleRows] = useState([]);
  const [groupRows, setGroupRows] = useState([]);
  const [locationRows, setLocationRows] = useState([]);
  const [agentRows, setAgentRows] = useState([]);
  const [dispositionFormDataRows, setDispositionFormDataRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [campaign, setCampaign] = useState({
    name: "",
    contactGroup: "",
    agentAssignment: "all",
    selectedQueue: "",
    selectedAgents: [],
    scriptOption: "new",
    scriptTitle: "",
    scriptDescription: "",
    scriptShortDescription: "",
    callRecording: "do_not_record",
    did: "",
    timeBetweenCalls: "",
    maxRetries: "",
    startDate: "",
    endDate: "",
    weekDays: [],
    startHour: "",
    endHour: "",
  });
  const [callGroupList, setCallGroupList] = useState([]);
  const [agentsList, setAgentsList] = useState([]);
  const [completedSteps, setCompletedSteps] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [filteredAgents, setFilteredAgents] = useState([]);
  const [isAgent, setIsAgent] = useState(false);
  const [isSuperamdin, setIsSuperadmin] = useState(false)
  const [liveAgents, setLiveAgents] = useState([
      {
        id: 1,
        agent: "Summer Sale",
        total_call: 5,
        answered: 2,
        total_talk_time: "01:00:00",
        status: "active",
      },
      {
        id: 2,
        agent: "Holiday Special",
        total_call: 5,
        answered: 2,
        total_talk_time: "01:00:00",
        status: "active",
      },
    ]);

    const [contacts, setContacts] = useState([
      {
        id: 1,
        name: "Summer Sale",
        address: '987, ynr, hr, in',
        number: '9991066739',
        company: "01:00:00",
        action: "active",
      },
      {
        id: 2,
        name: "Winter Sale",
        address: '987, ynr, hr, in',
        number: '9350233907',
        company: "01:00:00",
        action: "active",
      },
    ]);

    const [callHistory, setCallHistory] = useState([
      {
        id: 1,
        date_time: "2025-01-03 13:39:01",
        agent: 'Agent 1',
        customer: '9991066739',
        disposition: 'Normal Clearing',
        call_duration: "01:00:00",
      },
      {
        id: 2,
        date_time: "2025-01-03 13:39:01",
        agent: 'Agent 2',
        customer: '9991066739',
        disposition: 'Not Clearing',
        call_duration: "01:00:00",
      },
    ]);

    const [selectedAgent, setSelectedAgent] = useState("");
    const [selectedDisposition, setSelectedDisposition] = useState("");

    // Extract unique agents and dispositions
    const uniqueAgents = [...new Set(callHistory.map((item) => item.agent))];
    const uniqueDispositions = [...new Set(callHistory.map((item) => item.disposition))];
    const filteredCallHistoryData = useMemo(() => {
        return callHistory.filter((entry) => {
        return (
            (selectedAgent ? entry.agent === selectedAgent : true) &&
            (selectedDisposition ? entry.disposition === selectedDisposition : true)
        );
        });
    }, [callHistory, selectedAgent, selectedDisposition]);

      const [contactsData, setContactsData] = useState([]);

  const filteredContacts = contactsData.filter((contact) =>
    Object.values(contact)
      .join(" ")
      .toLowerCase()
      .includes(searchValue.toLowerCase())
  );

  function onCallGroupListSuccess(resp) {
    setCallGroupList(resp);
  } 
  function onAgentsListSuccess(resp) {
    setAgentsList(resp);
  }

  function onCampaignDataSuccess(resp) {
    setCampaign(resp);
    setCampaignPrompts(resp.campaigns);
    setLoading(false);
  }

  function onPromptsDataSuccess(resp) {
    setAllPrompts(resp);
  }

  function onContactsSuccess(resp) {
    let data = resp;
    if (filteredAgents.length > 0 && isAgent == true) {
      let filteredData = data?.filter((item) => {
        return (item?.primary_number == filteredAgents[0]?.agent_number) || (item?.alt1_number == filteredAgents[0]?.agent_number) || (item?.alt2_number == filteredAgents[0]?.agent_number)
      })
      setContactsData(filteredData);
    }
    else {
      setContactsData(resp);
    }
  }

  useEffect(() => {
    getApiCall(API_AGENT_GROUPS_LIST, {})
      .then(onCallGroupListSuccess)
      .catch(onError);

    getApiCall(API_AGENTS_LIST, {}).then(onAgentsListSuccess).catch(onError);

    const url = API_VOICE_CAMPAIGNS_GET_ONE.replace(":id", id);
    getApiCall(url, {}).then(onCampaignDataSuccess).catch(onError);

    const promptsUrl = `${API_PROMPT_ACTIVE_LIST}/all`;
    getApiCall(promptsUrl, {}).then(onPromptsDataSuccess).catch(onError);
  }, []);

  useEffect(() => {
    if (campaign?.voice_campaign_webhook_details?.length) {
      setWebhookRows(campaign.voice_campaign_webhook_details);
    } else {
      setWebhookRows([]);
    }

    if (campaign?.campaign_numbers && Array.isArray(campaign.campaign_numbers)) {
      setNumbersRows(campaign.campaign_numbers);
    } else {
      setNumbersRows([]);
    }

    if (campaign?.campaign_contact_group && Array.isArray(campaign.campaign_contact_group)) {
      const allMembers = campaign.campaign_contact_group.flatMap(
        (group) => group.voice_campaign_contact_group_details?.members || []
      );
      setContactMembers(allMembers);
    } else {
      setContactMembers([]);
    }

    if (campaign?.voice_campaigns_scripts_details) {
      setScriptDetails([campaign?.voice_campaigns_scripts_details]);
    } else {
      setScriptDetails([]);
    }

    if (
      campaign?.voice_campaigns_call_group_details &&
      Array.isArray(campaign.voice_campaigns_call_group_details)
    ) {
      setCallGroupRows(campaign.voice_campaigns_call_group_details);
    } else {
      setCallGroupRows([]);
    }

    if (
      campaign?.voice_campaigns_schedule &&
      Array.isArray(campaign.voice_campaigns_schedule)
    ) {
      setScheduleRows(campaign.voice_campaigns_schedule);
    } else {
      setScheduleRows([]);
    }

    if (
      campaign?.voice_campaigns_call_group_details &&
      Array.isArray(campaign.voice_campaigns_call_group_details)
    ) {
      const extractedAgents = campaign.voice_campaigns_call_group_details.flatMap(
        (callGroup) =>
          callGroup.agent_group_campaign_details?.agent_schedule_mappings?.map(
            (mapping) => mapping.agent_vc
          ) || []
      );
      setAgentRows(extractedAgents);
    } else {
      setAgentRows([]);
    }

    setGroupRows(campaign?.campaignGroups || []);
    setLocationRows(campaign?.campaignLocations || []);

    if (
      campaign?.disposition_form_data &&
      Array.isArray(campaign.disposition_form_data)
    ) {
      setDispositionFormDataRows(campaign.disposition_form_data);
    } else {
      setDispositionFormDataRows([]);
    }
  }, [campaign]);

  const campaignGroupNameBody = (row) =>
    row.voiceCampaignGroups?.group_name || "-";

  const campaignLocationNameBody = (row) =>
    row.voiceCampaignLocations?.location_name || row.location_name || "-";

  const weekDaysBody = (rowData) =>
    rowData.week_days ? rowData.week_days.join(", ") : "-";

  const groupNameBody = (rowData) =>
    rowData.agent_group_campaign_details?.group_name || "-";
  const managerBody = (rowData) =>
    rowData.agent_group_campaign_details?.manager || "-";
  const strategyBody = (rowData) =>
    rowData.agent_group_campaign_details?.strategy || "-";

  const webhookTypeBody = (rowData) =>
    rowData.sms_webhook_id ? "SMS Webhook" : "Webhook";

  const fullNameBody = (rowData) => `${rowData.first_name} ${rowData.last_name}`;

  const webhookNameBody = (rowData) =>
    rowData.sms_webhook?.webhook_name || rowData.webhook?.webhook_name || "-";

  const webhookIdBody = (rowData) =>
    rowData.sms_webhook?.id || rowData.webhook?.id || "-";

  const webhookUrlBody = (rowData) =>
    rowData.sms_webhook?.url || rowData.webhook?.url || "-";

  const actualNumberBody = (rowData) =>
    rowData.number_details_data?.actual_number || "-";

  const numberTypeBody = (rowData) =>
    rowData.number_details_data?.number_type || "-";

  const getDispositionFormFromCampaign = (data) => {
    const candidates = [
      data?.dispositionForm,
      data?.disposition_form,
      data?.disposition_form_details,
      data?.voice_campaign_disposition_form_details,
      data?.voice_campaigns_disposition_form_details,
      data?.campaignDispositionForm,
    ];

    for (const candidate of candidates) {
      if (candidate && typeof candidate === "object") return candidate;
    }
    return null;
  };

  const parseDispositionFields = (fields) => {
    if (!fields) return [];
    if (Array.isArray(fields)) return fields;
    if (typeof fields === "string") {
      try {
        const parsed = JSON.parse(fields);
        return Array.isArray(parsed) ? parsed : [];
      } catch {
        return [];
      }
    }
    return [];
  };

  const formatDateTime = (value) => {
    if (!value) return "-";
    const dt = new Date(value);
    if (Number.isNaN(dt.getTime())) return String(value);
    return dt.toLocaleString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    });
  };

  const dispositionForm = useMemo(
    () => getDispositionFormFromCampaign(campaign),
    [campaign],
  );

  const dispositionFormFields = useMemo(
    () => parseDispositionFields(dispositionForm?.fields),
    [dispositionForm],
  );

  const dispositionFormDataBody = (rowData) => <ScrollBox data={rowData?.data} />;

  const dispositionFormDataAgentBody = (rowData) =>
    rowData?.agent?.agent_name || rowData?.agent_id || "-";

  const dispositionFormDataAgentNumberBody = (rowData) =>
    rowData?.agent?.agent_number || "-";

  const dispositionFormDataFormBody = (rowData) =>
    rowData?.disposition_form?.name ||
    rowData?.disposition_form?.id ||
    rowData?.disposition_form_id ||
    "-";

  useEffect(() => {
    if (allPrompts.length && campaignPrompts.length) {
      const usedPromptIds = campaignPrompts.map(item => item.value);
    
      const matchedPrompts = allPrompts.filter(prompt =>
        usedPromptIds.includes(prompt.id)
      );

      setFilteredPrompts(matchedPrompts);
    }
  }, [allPrompts, campaignPrompts]);

  useEffect(() => {
    if(campaign?.call_group) {
      const url = API_CONTACT_GROUP_MEMBERS_UNDER_ONE_GROUP.replace(":id", campaign.call_group);
      getApiCall(url, {}).then(onContactsSuccess, onError);
    }
  }, [campaign, isAgent, filteredAgents]);

const fetchUserData = async () => {
  const rawUser = await AsyncStorage.getItem("user");

  if (!rawUser) {
    console.error("User data not found in AsyncStorage");
    return;
  }

  let user;
  try {
    user = JSON.parse(rawUser);
  } catch (e) {
    console.error("Invalid JSON in AsyncStorage user:", e);
    return;
  }

  if (user?.role === USER_ROLES.SUPERADMIN) {
    setIsSuperadmin(true)
  }

  if (user?.role === USER_ROLES.CALL_CENTRE_AGENT) {
    setFilteredAgents([user.agentData]);
    setIsAgent(true);
  } else {
    setIsAgent(false);
    setFilteredAgents([]);
  }
};

useEffect(() => {
  if (campaign?.agents?.length > 0 && agentsList?.length > 0) {
    const selectedAgentIds = campaign.agents;
    const newFilteredAgents = agentsList.filter(agent => 
      selectedAgentIds.includes(agent.id.toString())
    );
    setFilteredAgents(newFilteredAgents);
  } else {
    fetchUserData()
  }
}, [campaign, agentsList]);

  function onError(err) {
    if (typeof err !== "object" && err.includes("TokenExpiredError")) {
      errorCheck(err, navigate, setToastProps, setShowToast);
    } else {
      console.log(err);
    }
  }

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setCampaign((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const nextStep = () => {
    if (!completedSteps.includes(step)) {
      setCompletedSteps([...completedSteps, step]);
    }
    setStep((prev) => prev + 1);
  };

  const prevStep = () => setStep((prev) => prev - 1);

   const actionBodyTemplate = (rowData) => (
      <Dropdown align="end">
        <Dropdown.Toggle variant="link" className="p-0">
          <i className="pi pi-ellipsis-v" />
        </Dropdown.Toggle>
        <Dropdown.Menu>
          <Dropdown.Item onClick={() => handleAction("call", rowData.id)}>
            <i className="pi pi-pencil me-2" /> Call
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
    );

  const handleAction = (action, id) => {
    console.log(`Action: ${action} on campaign ${id}`);
  };

    const cardStyle = {
    border: "1px solid #e5e7eb",
    borderRadius: "6px",
    padding: "16px",
    flex: "1",
    boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
    };

    const statBoxStyle = {
    padding: "10px 16px",
    borderRadius: "6px",
    textAlign: "center",
    };

    const legendBox = (color) => ({
    display: "inline-block",
    width: "16px",
    height: "10px",
    backgroundColor: color,
    borderRadius: "2px",
    marginRight: "4px",
    });

    const doughnutData = {
    labels: ["Completed", "Remaining"],
    datasets: [
        {
        data: [(Number(campaign?.connected_calls) || 0), (Number(campaign?.total_nos) || 0) - (Number(campaign?.connected_calls) || 0)],
        backgroundColor: ["#2ebf3f", "#eb173b"],
        borderWidth: 0,
        },
    ],
    };

    const DOUGHNUT_COLORS_1 = ["#00fe04", "#c40000"];

    const dataDoughnut = doughnutData.labels.map((label, index) => ({
      name: label,
      value: doughnutData.datasets[0].data[index],
    }));

    const doughnutOptions = {
    cutout: "50%",
    plugins: {
        legend: {
        display: false,
        },
    },
    };

    const calculateDropRate = () => {
  const totalNos = Number(campaign?.total_nos) || 0;
  const connectedNumbers = Number(campaign?.connected_calls) || 0;
  
  // Handle edge cases
  if (totalNos === 0) return 0; // Prevent division by zero
  
  // Calculate drop rate percentage
  const dropRate = ((totalNos - connectedNumbers) / totalNos) * 100;
  
  // Round to 2 decimal places for cleaner display
  return Math.round(dropRate * 100) / 100;
}

    const calculateAvgConnection = () => {
  const totalNos = Number(campaign?.total_nos) || 0;
  const connectedNumbers = Number(campaign?.connected_calls) || 0;
  
  // Handle division by zero and invalid cases
  if (totalNos <= 0) return 0;
  
  // Calculate connection rate (0 to 1 scale)
  const connectionRate = connectedNumbers / totalNos;
  
  // Return as percentage (0-100) with 2 decimal places
  return Math.round(connectionRate * 100 * 100) / 100;
}

const [playingId, setPlayingId] = useState(null);
const [invalidAudioIds, setInvalidAudioIds] = useState([]);
const audioRefs = useRef({});

const handleAudioError = (id) => {
  setInvalidAudioIds((prev) => [...prev, id]);
};


const handlePlayPause = (id) => {
  const current = audioRefs.current[id];

  if (playingId && playingId !== id) {
    audioRefs.current[playingId]?.pause();
    audioRefs.current[playingId].currentTime = 0;
  }

  if (playingId === id) {
    current.pause();
    setPlayingId(null);
  } else {
    current.play();
    setPlayingId(id);
  }
};

const handleLoadedMetadata = (id) => {
  const duration = audioRefs.current[id]?.duration || 0; 
};

if (loading) {
  return <Loader />
}

  const renderStep = () => {
    switch (step) {
      case 1:
        return (
          <>
          {campaign?.campaign_type && campaign?.campaign_type != "1" && campaign?.campaign_type != "3" &&
          <div className="campaign-detail-card" style={cardStyle}>
  <p><strong>Template Type</strong></p>
  <p> 
    {{
      0: "Simple IVR",
      1: "DTMF",
      2: "Call Patch",
      3: "Custom IVR"
    }[campaign?.template_id] || "Unknown"}
  </p>
</div>}
<div className="campaign-detail-card" style={{ ...cardStyle, marginBottom: "20px", marginTop: "20px" }}>
<p><strong>DID(s)</strong></p>
          <div style={{ overflowX: "auto" }}>
            <DataTable
              value={numbersRows}
              paginator
              rows={5}
              tableStyle={{ minWidth: "100%" }}
              scrollable
              scrollHeight="flex"
            >
              <Column
                field="cli"
                header="ID"
                style={{ minWidth: "150px" }}
                headerStyle={{ padding: "1rem" }}
                bodyStyle={{ padding: "1rem" }}
              />
              <Column
                header="Actual Number"
                body={actualNumberBody}
                style={{ minWidth: "150px" }}
                headerStyle={{ padding: "1rem" }}
                bodyStyle={{ padding: "1rem" }}
              />
              <Column
                header="Number Type"
                body={numberTypeBody}
                style={{ minWidth: "150px" }}
                headerStyle={{ padding: "1rem" }}
                bodyStyle={{ padding: "1rem" }}
              />
            </DataTable>
          </div>
          </div>
          <div style={{ display: "flex", gap: "20px", marginBottom: "20px", marginTop: "20px" }}>
                <div className="campaign-detail-card" style={cardStyle}>
                <p><strong>Call Center</strong></p>
                <p>{campaign?.campaignCallCenter?.name || "-"}</p>
                </div>
                <div className="campaign-detail-card" style={cardStyle}>
                <p><strong>Company</strong></p>
                <p>{campaign?.campaignCompany?.name || "-"}</p>
                </div>
            </div>
          {scriptDetails?.length > 0 &&
          <div className="campaign-detail-card" style={{ ...cardStyle, marginBottom: "20px", marginTop: "20px" }}>
<p><strong>Script Used</strong></p>
          <div style={{ overflowX: "auto" }} className="broad-scrollbar">
            <DataTable
              value={scriptDetails}
              paginator
              rows={5}
              tableStyle={{ minWidth: "100%" }}
              scrollable
              scrollHeight="flex"
            >
              <Column
                field="id"
                header="ID"
                style={{ minWidth: "150px" }}
                headerStyle={{ padding: "1rem" }}
                bodyStyle={{ padding: "1rem" }}
              />
              <Column
                field="title"
                header="Title"
                style={{ minWidth: "150px" }}
                headerStyle={{ padding: "1rem" }}
                bodyStyle={{ padding: "1rem" }}
              />
              <Column
                field="short_description"
                header="Short Description"
                style={{ minWidth: "150px" }}
                headerStyle={{ padding: "1rem" }}
                bodyStyle={{ padding: "1rem" }}
              />
              <Column
                field="description"
                header="Description"
                style={{ minWidth: "150px" }}
                headerStyle={{ padding: "1rem" }}
                bodyStyle={{ padding: "1rem" }}
              />
            </DataTable>
          </div>
                      <style>
{`
  .broad-scrollbar::-webkit-scrollbar {
    height: 8px; 
  }
`}
</style>
          </div>}

          <div className="campaign-detail-card" style={{ ...cardStyle, marginBottom: "20px", marginTop: "20px" }}>
            <p style={{ marginBottom: "30px" }}><strong>Disposition Form Used</strong></p>
            {dispositionForm ? (
              <>
                <div style={{ display: "flex", gap: "80px", flexWrap: "wrap" }}>
                  <div>
                    <p style={{ marginBottom: 4, fontSize: "13px" }}><strong>Name</strong></p>
                    <p style={{ marginBottom: 0 }}>{dispositionForm?.name || "-"}</p>
                  </div>
                  <div>
                    <p style={{ marginBottom: 4, fontSize: "13px" }}><strong>Creation Date</strong></p>
                    <p style={{ marginBottom: 0 }}>{formatDateTime(dispositionForm?.created_at || dispositionForm?.createdAt)}</p>
                  </div>
                  <div>
                    <p style={{ marginBottom: 4, fontSize: "13px" }}><strong>Fields</strong></p>
                    <p style={{ marginBottom: 0 }}>{Array.isArray(dispositionFormFields) ? dispositionFormFields.length : 0}</p>
                  </div>
                </div>

                <div style={{ overflowX: "auto", marginTop: "12px" }} className="broad-scrollbar">
                  <DataTable
                    value={dispositionFormFields}
                    paginator
                    rows={5}
                    tableStyle={{ minWidth: "100%" }}
                    scrollable
                    scrollHeight="flex"
                    emptyMessage="No disposition fields found"
                  >
                    <Column
                      field="field_name"
                      header="Field Name"
                      style={{ minWidth: "180px" }}
                      headerStyle={{ padding: "1rem" }}
                      bodyStyle={{ padding: "1rem" }}
                    />
                    <Column
                      field="field_type"
                      header="Type"
                      style={{ minWidth: "120px" }}
                      headerStyle={{ padding: "1rem" }}
                      bodyStyle={{ padding: "1rem" }}
                    />
                    <Column
                      header="Required"
                      body={(rowData) => (rowData?.is_required ? "Yes" : "No")}
                      style={{ minWidth: "110px" }}
                      headerStyle={{ padding: "1rem" }}
                      bodyStyle={{ padding: "1rem" }}
                    />
                    <Column
                      header="Default"
                      body={(rowData) =>
                        rowData?.field_default === null ||
                        rowData?.field_default === undefined ||
                        rowData?.field_default === ""
                          ? "-"
                          : String(rowData.field_default)
                      }
                      style={{ minWidth: "140px" }}
                      headerStyle={{ padding: "1rem" }}
                      bodyStyle={{ padding: "1rem" }}
                    />
                    <Column
                      header="Min"
                      body={(rowData) =>
                        rowData?.field_min === null ||
                        rowData?.field_min === undefined ||
                        rowData?.field_min === ""
                          ? "-"
                          : String(rowData.field_min)
                      }
                      style={{ minWidth: "120px" }}
                      headerStyle={{ padding: "1rem" }}
                      bodyStyle={{ padding: "1rem" }}
                    />
                    <Column
                      header="Max"
                      body={(rowData) =>
                        rowData?.field_max === null ||
                        rowData?.field_max === undefined ||
                        rowData?.field_max === ""
                          ? "-"
                          : String(rowData.field_max)
                      }
                      style={{ minWidth: "120px" }}
                      headerStyle={{ padding: "1rem" }}
                      bodyStyle={{ padding: "1rem" }}
                    />
                  </DataTable>
                </div>
              </>
            ) : (
              <p style={{ marginBottom: 0 }}>
                No disposition form selected. Agents will see basic fields only (First Name, Last Name, Contact Number, Remarks).
              </p>
            )}
          </div>

          <div className="campaign-detail-card" style={{ ...cardStyle, marginBottom: "20px", marginTop: "20px" }}>
            <p><strong>Disposition Form Data</strong></p>
            <div style={{ overflowX: "auto" }} className="broad-scrollbar">
              <DataTable
                value={dispositionFormDataRows}
                paginator
                rows={5}
                tableStyle={{ minWidth: "100%" }}
                scrollable
                scrollHeight="flex"
                emptyMessage="No disposition form data found"
              >
                <Column
                  header="Form"
                  body={dispositionFormDataFormBody}
                  style={{ minWidth: "160px" }}
                  headerStyle={{ padding: "1rem" }}
                  bodyStyle={{ padding: "1rem" }}
                />
                <Column
                  header="Agent"
                  body={dispositionFormDataAgentBody}
                  style={{ minWidth: "160px" }}
                  headerStyle={{ padding: "1rem" }}
                  bodyStyle={{ padding: "1rem" }}
                />
                <Column
                  header="Agent Number"
                  body={dispositionFormDataAgentNumberBody}
                  style={{ minWidth: "150px" }}
                  headerStyle={{ padding: "1rem" }}
                  bodyStyle={{ padding: "1rem" }}
                />
                <Column
                  header="Date"
                  body={(rowData) => formatDateTime(rowData?.created_at)}
                  style={{ minWidth: "190px" }}
                  headerStyle={{ padding: "1rem" }}
                  bodyStyle={{ padding: "1rem" }}
                />
                <Column
                  header="Data"
                  body={dispositionFormDataBody}
                  style={{ minWidth: "320px" }}
                  headerStyle={{ padding: "1rem" }}
                  bodyStyle={{ padding: "1rem" }}
                />
              </DataTable>
            </div>
          </div>
          {filteredPrompts?.length > 0 &&
<div className="campaign-detail-card" style={{ ...cardStyle, marginBottom: "20px", marginTop: "20px" }}>
  <p><strong>Used Prompts</strong></p>

  <table style={{ width: "100%", borderCollapse: "collapse" }}>
    <thead>
      <tr style={{ backgroundColor: "#f5f5f5", textAlign: "left" }}>
        <th style={{ padding: "8px", borderBottom: "1px solid #ddd" }}>Prompt Name</th>
        <th style={{ padding: "8px", borderBottom: "1px solid #ddd" }}>Prompt ID</th>
        <th style={{ padding: "8px", borderBottom: "1px solid #ddd" }}>Category</th>
        <th style={{ padding: "8px", borderBottom: "1px solid #ddd" }}>Action</th>
      </tr>
    </thead>
    <tbody>
      {filteredPrompts?.map((item) => (
        <tr key={item.id}>
          <td style={{ padding: "8px", borderBottom: "1px solid #eee" }}>{item.prompt_name}</td>
          <td style={{ padding: "8px", borderBottom: "1px solid #eee" }}>{item.id}</td>
          <td style={{ padding: "8px", borderBottom: "1px solid #eee" }}>{item.prompt_category}</td>
          <td style={{ padding: "8px", borderBottom: "1px solid #eee" }}>
            <audio
              ref={(el) => (audioRefs.current[item.id] = el)}
              src={item.prompt_url}
              onLoadedMetadata={() => handleLoadedMetadata(item.id)}
              onEnded={() => setPlayingId(null)}
              onError={() => handleAudioError(item.id)}
            />
            <button
              onClick={() => {
                if (!invalidAudioIds.includes(item.id)) {
                  handlePlayPause(item.id);
                }
              }}
              style={{
                background: "none",
                border: "none",
                cursor: invalidAudioIds.includes(item.id) ? "not-allowed" : "pointer",
                opacity: invalidAudioIds.includes(item.id) ? 0.5 : 1
              }}
              title={
                invalidAudioIds.includes(item.id)
                  ? "Audio not supported"
                  : playingId === item.id
                  ? "Pause"
                  : "Play"
              }
              disabled={invalidAudioIds.includes(item.id)}
            >
              {playingId === item.id ? (
                <svg width="20" height="20" viewBox="0 0 24 24">
                  <path d="M6 5h4v14H6zM14 5h4v14h-4z" fill="currentColor" />
                </svg>
              ) : (
                <svg width="20" height="20" viewBox="0 0 24 24">
                  <path d="M8 5v14l11-7z" fill="currentColor" />
                </svg>
              )}
            </button>
          </td>
        </tr>
      ))}
    </tbody>
  </table>
</div>
}
{groupRows?.length > 0 &&
<div className="campaign-detail-card" style={{ ...cardStyle, marginBottom: "20px", marginTop: "20px" }}>
      <p><strong>Campaign Group</strong></p>
      <div>
        <DataTable
          value={groupRows}
          paginator
          rows={5}
          tableStyle={{ minWidth: "100%" }}
          scrollable
          scrollHeight="flex"
        >
          <Column
            field="group_id"
            header="Group ID"
            style={{ minWidth: "100px" }}
            headerStyle={{ padding: "1rem" }}
            bodyStyle={{ padding: "1rem" }}
          />
          <Column
            header="Group Name"
            body={campaignGroupNameBody}
            style={{ minWidth: "180px" }}
            headerStyle={{ padding: "1rem" }}
            bodyStyle={{ padding: "1rem" }}
          />
        </DataTable>
      </div>
</div>}

{locationRows?.length > 0 &&
<div className="campaign-detail-card" style={{ ...cardStyle, marginBottom: "20px", marginTop: "20px" }}>
      <p><strong>Campaign Location</strong></p>
      <div>
        <DataTable
          value={locationRows}
          paginator
          rows={5}
          tableStyle={{ minWidth: "100%" }}
          scrollable
          scrollHeight="flex"
        >
          <Column
            field="location_id"
            header="Location ID"
            style={{ minWidth: "100px" }}
            headerStyle={{ padding: "1rem" }}
            bodyStyle={{ padding: "1rem" }}
          />
          <Column
            header="Location Name"
            body={campaignLocationNameBody}
            style={{ minWidth: "180px" }}
            headerStyle={{ padding: "1rem" }}
            bodyStyle={{ padding: "1rem" }}
          />
        </DataTable>
      </div>
    </div>}
<div style={{ display: "flex", gap: "20px", marginBottom: "20px", marginTop: "20px" }}>
  {(campaign?.template_id == "1") &&
<div style={{...cardStyle, flex: "none", width: "170px", height: "80px"}}>
<p style={{ marginTop: "-5px" }}><strong>DTMF</strong></p>
<p style={{ marginTop: "-10px" }}>{campaign?.dtmf || "-"}</p>
</div>
    }
    {campaign?.campaign_type && campaign?.campaign_type != "1" && campaign?.campaign_type != "3" &&
<div style={{...cardStyle, flex: "none", width: "170px", height: "80px"}}>
<p style={{ marginTop: "-5px" }}><strong>Menu Wait Time</strong></p>
<p style={{ marginTop: "-10px" }}>{campaign?.menu_wait_time || "-"}</p>
</div>}
{campaign?.campaign_type && campaign?.campaign_type != "1" && campaign?.campaign_type != "3" &&
<div style={{...cardStyle, flex: "none", width: "170px", height: "80px"}}>
<p style={{ marginTop: "-5px" }}><strong>Re Prompt</strong></p>
<p style={{ marginTop: "-10px" }}>{campaign?.re_prompt || "-"}</p>
</div>}
</div>
{callGroupRows?.length > 0 && <div style={{...cardStyle, marginBottom: "20px", marginTop: "20px" }}>
      <p><strong>Call Group Data</strong></p>
      <div style={{ overflowX: "auto" }}>
        <DataTable
          value={callGroupRows}
          paginator
          rows={5}
          tableStyle={{ minWidth: "100%" }}
          scrollable
          scrollHeight="flex"
        >
          <Column
            field="call_group_id"
            header="Call Group ID"
            style={{ minWidth: "100px" }}
            headerStyle={{ padding: "1rem" }}
            bodyStyle={{ padding: "1rem" }}
          />
          <Column
            header="Group Name"
            body={groupNameBody}
            style={{ minWidth: "180px" }}
            headerStyle={{ padding: "1rem" }}
            bodyStyle={{ padding: "1rem" }}
          />
          <Column
            header="Group Owner"
            body={managerBody}
            style={{ minWidth: "180px" }}
            headerStyle={{ padding: "1rem" }}
            bodyStyle={{ padding: "1rem" }}
          />
          <Column
            header="Strategy"
            body={strategyBody}
            style={{ minWidth: "180px" }}
            headerStyle={{ padding: "1rem" }}
            bodyStyle={{ padding: "1rem" }}
          />
          <Column
            field="dtmf"
            header="DTMF"
            style={{ minWidth: "100px" }}
            headerStyle={{ padding: "1rem" }}
            bodyStyle={{ padding: "1rem" }}
          />
        </DataTable>
      </div>
    </div>}
    {scheduleRows?.length > 0 && <div style={{...cardStyle, marginBottom: "20px", marginTop: "20px" }}>
      <p><strong>Schedule Details</strong></p>
      <div style={{ overflowX: "auto" }}>
        <DataTable
          value={scheduleRows}
          paginator
          rows={5}
          tableStyle={{ minWidth: "100%" }}
          scrollable
          scrollHeight="flex"
        >
          <Column
            field="start_time"
            header="Start Time"
            style={{ minWidth: "100px" }}
            headerStyle={{ padding: "1rem" }}
            bodyStyle={{ padding: "1rem" }}
          />
          <Column
            field="end_time"
            header="End Time"
            style={{ minWidth: "100px" }}
            headerStyle={{ padding: "1rem" }}
            bodyStyle={{ padding: "1rem" }}
          />
          <Column
            header="Week Days"
            body={weekDaysBody}
            style={{ minWidth: "250px" }}
            headerStyle={{ padding: "1rem" }}
            bodyStyle={{ padding: "1rem" }}
          />
        </DataTable>
      </div>
    </div>}
          <div style={{ display: "flex", gap: "20px", marginBottom: "20px", marginTop: "20px" }}>
                <div className="campaign-detail-card" style={cardStyle}>
                <p><strong>Total Talk-time</strong></p>
                <p>{campaign?.pulse_duration || "0"}s</p>
                </div>
                <div className="campaign-detail-card" style={cardStyle}>
                <p><strong>Drop Rate</strong></p>
                <p>{calculateDropRate()}%</p>
                </div>
                <div className="campaign-detail-card" style={cardStyle}>
                <p><strong>Average Connection</strong></p>
                <p>{calculateAvgConnection()}%</p>
                </div>
            </div>

<div style={{ display: "flex", gap: "20px", marginBottom: "20px" }}>
                <div className="campaign-detail-card" style={{ ...cardStyle, flex: 1 }}>
                <p><strong>Campaign statistics</strong></p>

                <div style={{ display: "flex", gap: "20px", marginTop: "10px" }}>
                    <div><span style={legendBox("#2ebf3f")} /> Completed</div>
                    <div><span style={legendBox("#eb173b")} /> Remaining</div>
                </div>

                <div style={{ display: "flex", justifyContent: "center", margin: "20px 0" }}>
                    <div style={{ width: "120px", height: "120px" }}>
                        <ResponsiveContainer width="100%" height={120}>
                          <PieChart>
                            <Pie
                              data={dataDoughnut}
                              cx="50%"
                              cy="50%"
                              innerRadius={30}
                              outerRadius={50}
                              paddingAngle={2}
                              dataKey="value"
                              nameKey="name"
                            >
                              {dataDoughnut.map((entry, index) => (
                                <Cell key={`cell-${index}`} fill={DOUGHNUT_COLORS_1[index % DOUGHNUT_COLORS_1.length]} />
                              ))}
                            </Pie>
                            <Tooltip />
                            {/* <Legend /> */}
                          </PieChart>
                        </ResponsiveContainer>
                    </div>
                </div>
                
                <div style={{ display: "flex", justifyContent: "space-around", fontWeight: "bold" }}>
                    <div>
                    <p>{campaign?.total_nos}</p>
                    <p style={{ fontWeight: "normal" }}>Total leads</p>
                    </div>
                    <div>
                    <p>{campaign?.connected_calls}</p>
                    <p style={{ fontWeight: "normal" }}>Completed</p>
                    </div>
                    <div>
                    <p>{(Number(campaign?.total_nos) || 0) - (Number(campaign?.connected_calls) || 0)}</p>
                    <p style={{ fontWeight: "normal" }}>Remaining</p>
                    </div>
                </div>
                </div>
                <div className="campaign-detail-card" style={{ ...cardStyle, flex: 1 }}>
                <p><strong>Call statistics</strong></p>
                <div style={{ display: "flex", justifyContent: "space-around", marginTop: "20px" }}>
                    {[
                    { label: "Total calls", value: campaign?.total_nos },
                    { label: "Answered", value: campaign?.connected_calls },
                    { label: "Busy", value: 0 },
                    { label: "Missed", value: 0 },
                    { label: "Failed", value: Number(campaign?.total_nos || 0) - Number(campaign?.connected_calls || 0) },
                    ].map((item, idx) => (
                    <div key={idx} className="campaign-detail-statbox" style={statBoxStyle}>
                        <p style={{ fontSize: "1.2rem", fontWeight: "bold" }}>{item.value}</p>
                        <p style={{ fontSize: "0.9rem" }}>{item.label}</p>
                    </div>
                    ))}
                </div>
                </div>
            </div>
            {/* {campaign?.campaign_type && campaign?.campaign_type != "1" && campaign?.campaign_type != "3" &&
            <div className="campaign-detail-card" style={cardStyle}>
                <p><strong>Peak call hours</strong></p>
                <div style={{ marginTop: "10px", color: "#999" }}></div>
            </div>} */}

</>

        );
      case 2:
        return (
            <div className="pb-4">
                <div style={{ overflowX: "auto" }}>
                    <DataTable
                        value={agentRows}
                        scrollable
                        scrollHeight="flex"
                        tableStyle={{ minWidth: "100%" }}
                        // className="p-datatable-striped p-datatable-gridlines p-datatable-sm"
                        paginator
                        rows={5}
                        //   rowsPerPageOptions={[5, 10, 25]}
                        rowClassName={(rowData) => `${rowData.status} p-3`}
                    >
                      <Column
                        field="agent_name"
                        header="Agent"
                        style={{ minWidth: "150px" }}
                        headerStyle={{ padding: "1rem" }}
                        bodyStyle={{ padding: "1rem" }}
                      />

                        <Column
                          field="agent_number"
                          header="Agent Number"
                          style={{ minWidth: "180px" }}
                          headerStyle={{ padding: "1rem" }}
                          bodyStyle={{ padding: "1rem" }}
                        />
                        <Column
                          field="email_id"
                          header="Agent Email"
                          style={{ minWidth: "250px" }}
                          headerStyle={{ padding: "1rem" }}
                          bodyStyle={{ padding: "1rem" }}
                        />
                        <Column
                          field="login_status"
                          header="Status"
                          style={{ minWidth: "100px" }}
                          headerStyle={{ padding: "1rem" }}
                          bodyStyle={{ padding: "1rem" }}
                          body={(rowData) => {
                            if(rowData?.login_status == 0) {
                              return "Inactive"
                            } else {
                              return "Active"
                            }
                          }}
                        />
                    </DataTable>
                </div>
            </div>
        );
      case 3:
        return (
            <div className="pb-4">
                <div className="d-flex align-items-center flex-wrap">
                    <Form className="d-flex align-items-center">
                        <Form.Control
                          placeholder="Search Contacts"
                          type="text"
                          value={searchValue}
                          onChange={(e) => setSearchValue(e.target.value)}
                          style={{ maxWidth: "250px" , marginBottom: '10px'}}
                       />
                    </Form>
                </div>
                <div style={{ overflowX: "auto" }}>
                    <DataTable
          value={contactMembers}
          paginator
          rows={5}
          tableStyle={{ minWidth: "100%" }}
          scrollable
          scrollHeight="flex"
        >
          <Column
            header="Name"
            body={fullNameBody}
            style={{ minWidth: "180px" }}
            headerStyle={{ padding: "1rem" }}
            bodyStyle={{ padding: "1rem" }}
          />
          <Column
            field="primary_number"
            header="Primary Number"
            style={{ minWidth: "150px" }}
            headerStyle={{ padding: "1rem" }}
            bodyStyle={{ padding: "1rem" }}
          />
          <Column
            field="alt1_number"
            header="Alt 1 Number"
            style={{ minWidth: "150px" }}
            headerStyle={{ padding: "1rem" }}
            bodyStyle={{ padding: "1rem" }}
          />
          <Column
            field="alt2_number"
            header="Alt 2 Number"
            style={{ minWidth: "150px" }}
            headerStyle={{ padding: "1rem" }}
            bodyStyle={{ padding: "1rem" }}
          />
          <Column
            field="company"
            header="Company"
            style={{ minWidth: "180px" }}
            headerStyle={{ padding: "1rem" }}
            bodyStyle={{ padding: "1rem" }}
          />
          <Column
            field="city"
            header="City"
            style={{ minWidth: "120px" }}
            headerStyle={{ padding: "1rem" }}
            bodyStyle={{ padding: "1rem" }}
          />
        </DataTable>
                </div>
            </div>
        );
      case 4:
        return (
            <div className="pb-4">
                    <div className="d-flex align-items-center flex-wrap gap-3 mb-3">
                        <Form.Select
                        value={selectedAgent}
                        onChange={(e) => setSelectedAgent(e.target.value)}
                        style={{ maxWidth: "200px" }}
                        >
                        <option value="">All Agents</option>
                        {uniqueAgents.map((agent, idx) => (
                            <option key={idx} value={agent}>
                            {agent}
                            </option>
                        ))}
                        </Form.Select>

                        <Form.Select
                        value={selectedDisposition}
                        onChange={(e) => setSelectedDisposition(e.target.value)}
                        style={{ maxWidth: "200px" }}
                        >
                        <option value="">All Dispositions</option>
                        {uniqueDispositions.map((dispo, idx) => (
                            <option key={idx} value={dispo}>
                            {dispo}
                            </option>
                        ))}
                        </Form.Select>
                    </div>

                <div style={{ overflowX: "auto" }}>
                    <DataTable
                        value={filteredCallHistoryData}
                        scrollable
                        scrollHeight="flex"
                        tableStyle={{ minWidth: "100%" }}
                        paginator
                        rows={5}
                        rowClassName={(rowData) => `${rowData.status} p-3`}
                    >
                      <Column
                        field="date_time"
                        header="Date/Time"
                        style={{ minWidth: "150px" }}
                        headerStyle={{ padding: "1rem" }}
                        bodyStyle={{ padding: "1rem" }}
                      />

                        <Column
                          field="agent"
                          header="Agent"

                          style={{ minWidth: "180px" }}
                          headerStyle={{ padding: "1rem" }}
                          bodyStyle={{ padding: "1rem" }}
                        />
                        <Column
                          field="customer"
                          header="Customer"
                          style={{ minWidth: "250px" }}
                          headerStyle={{ padding: "1rem" }}
                          bodyStyle={{ padding: "1rem" }}
                        />
                        <Column
                          field="disposition"
                          header="Disposition"
                          style={{ minWidth: "180px" }}
                          headerStyle={{ padding: "1rem" }}
                          bodyStyle={{ padding: "1rem" }}
                        />
                        <Column
                          field="call_duration"
                          header="Call Duration"
                          style={{ width: "80px" }}
                          headerStyle={{ padding: "1rem" }}
                          bodyStyle={{ padding: "1rem"}}
                        />
                    </DataTable>
                </div>
            </div>
        );
      case 5: 
        return (
          <div className="pb-4">
          <div style={{ overflowX: "auto" }}>
            <DataTable
              value={webhookRows}
              paginator
              rows={15}
              tableStyle={{ minWidth: "100%" }}
              scrollable
              scrollHeight="flex"
            >
              <Column
                header="ID"
                body={webhookIdBody}
                style={{ minWidth: "100px" }}
                headerStyle={{ padding: "1rem" }}
                bodyStyle={{ padding: "1rem" }}
              />
              <Column
                header="Type"
                body={webhookTypeBody}
                style={{ minWidth: "150px" }}
                headerStyle={{ padding: "1rem" }}
                bodyStyle={{ padding: "1rem" }}
              />
              <Column
                header="Name"
                body={webhookNameBody}
                style={{ minWidth: "200px" }}
                headerStyle={{ padding: "1rem" }}
                bodyStyle={{ padding: "1rem" }}
              />
              <Column
                field="event"
                header="Event"
                style={{ minWidth: "150px" }}
                headerStyle={{ padding: "1rem" }}
                bodyStyle={{ padding: "1rem" }}
              />
              <Column
                field="duration"
                header="Duration"
                style={{ minWidth: "100px" }}
                headerStyle={{ padding: "1rem" }}
                bodyStyle={{ padding: "1rem" }}
              />
              <Column
                header="URL"
                body={webhookUrlBody}
                style={{ minWidth: "250px" }}
                headerStyle={{ padding: "1rem" }}
                bodyStyle={{ padding: "1rem" }}
              />
              <Column
                field="req_type"
                header="Request Type"
                style={{ minWidth: "250px" }}
                headerStyle={{ padding: "1rem" }}
                bodyStyle={{ padding: "1rem" }}
              />
              <Column header="Payload" body={payloadBody} />
              <Column header="SMS Header" body={smsHeaderBody} />
              <Column header="SMS Payload" body={smsPayloadBody} />
              <Column header="Webhook Body" body={webhookBody} />
              <Column header="Webhook Header" body={webhookHeader} />
            </DataTable>
          </div>
        </div>
        )

      default:
        return null;
    }
  };

    const statusBodyTemplate = (camp_status) => {
      camp_status = Number(camp_status);
    const statusMap = {
      0: { label: "Ready", color: "#e0a800" },
      1: { label: "Running", color: "#218838" },
      2: { label: "Completed", color: "#191cbcff" },
      3: { label: "Low Balance", color: "#bcac19ff" },
      4: { label: "Error", color: "#bc1919ff" },
      5: { label: "Error", color: "#bc1919ff" },
      6: { label: "Cancelling", color: "#d07900ff" },
      7: { label: "Cancelled", color: "#be0066ff" },
      8: { label: "Pausing", color: "#138496" },
      9: { label: "Paused", color: "#035fa5ff" },
      10: { label: "Resume", color: "#03cf2fff" },
      21: { label: "DND Processing", color: "#cf5b03ff" },
      22: { label: "Waiting For Ch...", color: "#cf5b03ff" },
    };

    const status = statusMap[camp_status];

    return (
      <span
        style={{
          display: "inline-block",
          padding: "0.5em 0.75em",
          fontSize: "0.75em",
          fontWeight: 700,
          lineHeight: 1,
          color: "white",
          textAlign: "center",
          whiteSpace: "nowrap",
          verticalAlign: "middle",
          borderRadius: "0.3rem",
          backgroundColor: status.color,
          minWidth: "85px",
          boxShadow: "inset 0 1px 0 rgba(255,255,255,0.15)",
          textShadow: "0 1px 1px rgba(0,0,0,0.1)",
        }}
      >
        {status.label}
      </span>
    );
  };



  return (
    <>
      {/* <StatsBar /> */}
      <Container
        className="campaign-detail-page"
        style={{
          padding: 0,
          margin: "2rem auto",
          boxShadow: "0 4px 20px rgba(0, 0, 0, 0.08)",
          borderRadius: "10px",
          overflow: "hidden",
        }}
      >
        <Card className="campaign-detail-surface" style={{ border: "none" }}>
          <Card.Header
            className="campaign-detail-header"
            style={{
              padding: "0",
              borderRadius: "8px 8px 0 0",
              boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
            }}
          >
            <div
            style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "0.5rem 1rem",
                borderBottom: "1px solid #e9ecef",
            }}
            >
            <div style={{ display: "flex", alignItems: "center", gap: "1rem" }}>
                <Button
                onClick={() => navigate("/campaigns")}
                className="campaign-detail-back-btn"
                style={{
                    color: "#4f46e5",
                    border: "1px solid #c3c3c3",
                    padding: "0.45rem 1rem",
                    borderRadius: "999px",
                    display: "flex",
                    alignItems: "center",
                    fontSize: "0.85rem",
                    fontWeight: 500,
                    boxShadow: "none",
                }}
                >
                <FaArrowLeft style={{ marginRight: "0.5rem", fontSize: "0.9rem" }} />
                Go back
                </Button>

                <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
                <span style={{ fontSize: "1rem", fontWeight: 500 }}>
                    Outbound Campaigns / <strong>{campaign?.campaign_name}</strong>
                </span>
                {campaign?.campaign_status && <span>
                  {statusBodyTemplate(campaign?.campaign_status)}
                </span>}
                </div>
            </div>

            {!isSuperamdin && (
              <button
              // onClick={() => navigate('/remarks')}
              style={{
                  backgroundColor: "#2f80ed",
                  color: "#fff",
                  fontWeight: 500,
                  border: "none",
                  borderRadius: "6px",
                  padding: "0.45rem 1rem",
                  fontSize: "0.85rem",
                  cursor: "pointer",
              }}
              >
              Join campaign
              </button>
            )}
            </div>

            <Nav
              variant="tabs"
              defaultActiveKey="#first"
              style={{
                borderBottom: "none",
                padding: "0 1rem",
              }}
            >
              <Nav.Item>
                <Nav.Link
                  href="#"
                  onClick={() => setStep(1)}
                  active={step === 1}
                  style={{
                    color:
                      step === 1
                        ? "#4f46e5"
                        : completedSteps.includes(1)
                        ? "#10b981"
                        : "#6b7280",
                    fontWeight: 600,
                    padding: "1rem 1.5rem",
                    borderRadius: "0",
                    transition: "all 0.3s ease",
                    backgroundColor: "transparent",
                    border: "none",
                    display: "flex",
                    alignItems: "center",
                    gap: "0.75rem",
                    fontSize: "0.9375rem",
                    position: "relative",
                    zIndex: 2,
                    boxShadow: "none",
                    borderBottom:
                      step === 1
                        ? "3px solid #4f46e5"
                        : completedSteps.includes(1)
                        ? "3px solid #10b981"
                        : "none",
                  }}
                >
                  Overview
                  {completedSteps.includes(1) && step !== 1 && (
                    <FaCheckCircle
                      style={{
                        color: "#10b981",
                        fontSize: "0.9rem",
                        marginLeft: "0.25rem",
                      }}
                    />
                  )}
                </Nav.Link>
              </Nav.Item>

              {campaign?.template_id !== "1" &&
              <Nav.Item>
                <Nav.Link
                  href="#"
                  onClick={() => setStep(2)}
                  active={step === 2}
                  style={{
                    color:
                      step === 2
                        ? "#4f46e5"
                        : completedSteps.includes(2)
                        ? "#10b981"
                        : "#6b7280",
                    fontWeight: 600,
                    padding: "1rem 1.5rem",
                    borderRadius: "0",
                    transition: "all 0.3s ease",
                    backgroundColor: "transparent",
                    border: "none",
                    display: "flex",
                    alignItems: "center",
                    gap: "0.75rem",
                    fontSize: "0.9375rem",
                    position: "relative",
                    zIndex: 2,
                    boxShadow: "none",
                    borderBottom:
                      step === 2
                        ? "3px solid #4f46e5"
                        : completedSteps.includes(2)
                        ? "3px solid #10b981"
                        : "none",
                  }}
                >
                  Live Agents
                  {completedSteps.includes(2) && step !== 2 && (
                    <FaCheckCircle
                      style={{
                        color: "#10b981",
                        fontSize: "0.9rem",
                        marginLeft: "0.25rem",
                      }}
                    />
                  )}
                </Nav.Link>
              </Nav.Item>
              }

              <Nav.Item>
                <Nav.Link
                  href="#"
                  onClick={() => setStep(3)}
                  active={step === 3}
                  style={{
                    color:
                      step === 3
                        ? "#4f46e5"
                        : completedSteps.includes(3)
                        ? "#10b981"
                        : "#6b7280",
                    fontWeight: 600,
                    padding: "1rem 1.5rem",
                    borderRadius: "0",
                    transition: "all 0.3s ease",
                    backgroundColor: "transparent",
                    border: "none",
                    display: "flex",
                    alignItems: "center",
                    gap: "0.75rem",
                    fontSize: "0.9375rem",
                    position: "relative",
                    zIndex: 2,
                    boxShadow: "none",
                    borderBottom:
                      step === 3
                        ? "3px solid #4f46e5"
                        : completedSteps.includes(3)
                        ? "3px solid #10b981"
                        : "none",
                  }}
                >
                  Contacts
                  {completedSteps.includes(3) && step !== 3 && (
                    <FaCheckCircle
                      style={{
                        color: "#10b981",
                        fontSize: "0.9rem",
                        marginLeft: "0.25rem",
                      }}
                    />
                  )}
                </Nav.Link>
              </Nav.Item>

              <Nav.Item>
                <Nav.Link
                  href="#"
                  onClick={() => setStep(4)}
                  active={step === 4}
                  style={{
                    color:
                      step === 4
                        ? "#4f46e5"
                        : completedSteps.includes(4)
                        ? "#10b981"
                        : "#6b7280",
                    fontWeight: 600,
                    padding: "1rem 1.5rem",
                    borderRadius: "0",
                    transition: "all 0.3s ease",
                    backgroundColor: "transparent",
                    border: "none",
                    display: "flex",
                    alignItems: "center",
                    gap: "0.75rem",
                    fontSize: "0.9375rem",
                    position: "relative",
                    zIndex: 2,
                    boxShadow: "none",
                    borderBottom:
                      step === 4
                        ? "3px solid #4f46e5"
                        : completedSteps.includes(4)
                        ? "3px solid #10b981"
                        : "none",
                  }}
                >
                  Call History
                  {completedSteps.includes(4) && step !== 4 && (
                    <FaCheckCircle
                      style={{
                        color: "#10b981",
                        fontSize: "0.9rem",
                        marginLeft: "0.25rem",
                      }}
                    />
                  )}
                </Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link
                  href="#"
                  onClick={() => setStep(5)}
                  active={step === 5}
                  style={{
                    color:
                      step === 5
                        ? "#4f46e5"
                        : completedSteps.includes(5)
                        ? "#10b981"
                        : "#6b7280",
                    fontWeight: 600,
                    padding: "1rem 1.5rem",
                    borderRadius: "0",
                    transition: "all 0.3s ease",
                    backgroundColor: "transparent",
                    border: "none",
                    display: "flex",
                    alignItems: "center",
                    gap: "0.75rem",
                    fontSize: "0.9375rem",
                    position: "relative",
                    zIndex: 2,
                    boxShadow: "none",
                    borderBottom:
                      step === 5
                        ? "3px solid #4f46e5"
                        : completedSteps.includes(5)
                        ? "3px solid #10b981"
                        : "none",
                  }}
                >
                  Webhooks
                  {completedSteps.includes(5) && step !== 5 && (
                    <FaCheckCircle
                      style={{
                        color: "#10b981",
                        fontSize: "0.9rem",
                        marginLeft: "0.25rem",
                      }}
                    />
                  )}
                </Nav.Link>
              </Nav.Item>
            </Nav>
          </Card.Header>
          <Card.Body style={{ padding: "2rem" }}>
            <Card.Title style={{ color: "#212529", fontWeight: 500 }}>
              {/* {step === 2 && "Script"} */}
              {/* {step === 3 && "Campaign Settings"} */}
              {/* {step === 4 && "Scheduling"} */}
            </Card.Title>
            {renderStep()}
          </Card.Body>
        </Card>
      </Container>
    </>
  );
};

export default CampaignDetail;
